import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Skeleton,
  Typography,
} from '@mui/material';
import { useDisclose } from 'basic-react-hooks';
import { EVENT_NAME } from 'constant/eventName';
import { dispatchEvent } from 'hooks/useAddEvent';
import { useMainContext } from 'pages/PublicPage/Layout';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { show } from 'redux/reducers/snackbar';
import { buyBucket, getVerificationBucket } from 'rest_client/publicUserClient';

const BuyCredits = ({ setInvoices, setLoading = () => {}, ...props }) => {
  const dispatch = useDispatch();
  const [loadingId, setLoadingId] = useState(null);
  const {
    isOpen: isLoading,
    onOpen: onOpenLoading,
    onClose: onCloseLoading,
  } = useDisclose();
  const { buckets, setBuckets } = useMainContext();

  useEffect(() => {
    if (loadingId) {
      setLoading(true);
    } else {
      setLoading(false);
    }

    return () => {
      setLoading(false);
    };
  }, [loadingId]);

  const onFetchListBucket = async () => {
    try {
      onOpenLoading();
      const { data } = await getVerificationBucket({
        page: 1,
        perPage: 1000,
        sortBy: 'createdAt',
      });
      setBuckets(data.data);
    } catch (error) {
      console.log(error);
    }
    onCloseLoading();
  };

  useEffect(() => {
    if (buckets?.length === 0) {
      onFetchListBucket();
    }
  }, []);

  const onClickBuy = async (item) => {
    try {
      setLoadingId(item._id);
      const { data } = await buyBucket(item._id);
      setInvoices(data.data);
      dispatchEvent(EVENT_NAME.fetchInvoices);
    } catch (error) {
      console.log('error in buy:', error);
      dispatch(
        show({
          message: typeof error === 'string' ? error : error.message,
          severity: 'error',
        }),
      );
    }
    setLoadingId(null);
  };

  return (
    <Box p={'24px'}>
      <Typography fontWeight={700} fontSize={24}>
        Buy Credit
      </Typography>
      <Box mt={2}>
        <Grid container spacing={2}>
          {isLoading && (
            <>
              {Array.from({ length: 3 }).map((_, i) => (
                <Grid item xs={12} sm={6} md={4} key={i}>
                  <Skeleton
                    key={i}
                    variant="rounded"
                    width={'100%'}
                    height={'150px'}
                  />
                </Grid>
              ))}
            </>
          )}
          {!isLoading &&
            buckets.map((i) => {
              const itemIsLoading = loadingId === i._id;
              return (
                <Grid item xs={12} sm={6} md={6} key={i.name}>
                  <Box
                    sx={{
                      borderRadius: '12px',
                      bgcolor: 'rgba(246, 246, 246, 1)',
                      border: '1px solid',
                      borderColor: 'rgba(246, 246, 246, 1)',
                      p: 2,
                      transition: 'all 0.3s',
                      '&:hover': {
                        borderColor: 'rgba(94, 196, 172, 1)',
                        backgroundColor: 'white',
                        '& .MuiButton-root': {
                          bgcolor: 'rgba(94, 196, 172, 1)',
                          color: 'white',
                        },
                      },
                    }}
                  >
                    <Box>
                      <Typography
                        textAlign={'center'}
                        fontWeight={700}
                        fontSize={18}
                      >
                        {i.credits} credits
                      </Typography>
                      <Typography
                        fontWeight={500}
                        fontSize={16}
                        color={'rgba(10, 9, 11, 0.6)'}
                        mt={'4px'}
                        textAlign={'center'}
                      >
                        {i.price.toLocaleString()} UGX
                      </Typography>
                    </Box>
                    <Button
                      //   variant="contained"
                      sx={{
                        width: '100px',
                        color: itemIsLoading ? 'white' : 'black',
                        bgcolor: itemIsLoading
                          ? 'rgba(94, 196, 172, 1)'
                          : 'white',
                        mt: 3,
                        height: '40px',
                        mx: 'auto',
                        display: 'block',
                      }}
                      disabled={Boolean(loadingId)}
                      onClick={() => onClickBuy(i)}
                    >
                      {itemIsLoading ? (
                        <CircularProgress
                          size={20}
                          sx={{
                            color: 'white',
                          }}
                        />
                      ) : (
                        'Buy'
                      )}
                    </Button>
                  </Box>
                </Grid>
              );
            })}
        </Grid>
      </Box>
    </Box>
  );
};

export default BuyCredits;
